import { cn } from "../../utils";

type TextDescriptionProps = {
  children: React.ReactNode;
  className?: string;
};

export function TextDescription({ children, className }: TextDescriptionProps) {
  return (
    <p className={cn("text-xs font-normal text-gray-600", className)}>
      {children}
    </p>
  );
}

export default TextDescription;
